export default __webpack_public_path__ + "static/media/image-cover.6d7e7d1a.png";